import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/observable/of';

@Injectable()
export class eventsService {
    private serverUrl = environment.serverUrl
    private addedToCartUrl = 'event/added-to-cart';

    constructor(private http: HttpClient) { }

    addedToCartEvent(orders, addedItemObj): Observable<any> {
        let data = this.makeAddedToCartPayload(orders, addedItemObj);
        return this.http.post(this.serverUrl + this.addedToCartUrl, data);
    }

    private makeAddedToCartPayload(orders, addedItemObj) {
        let requestObj: any = {
            orders: [],
            addedItem: {
                date: addedItemObj.selectedDate,
                item: {
                    quantity: addedItemObj.item.count,
                    id: addedItemObj.item.zf_id
                }
            }
        };
        orders.forEach(dateObj => {
            const items = [];
            dateObj.nextDayDate = new Date((new Date(dateObj.date)).getTime() + (60 * 60 * 24 * 1000));
            dateObj.nextDayDate = new Date(dateObj.nextDayDate).toISOString().split('T')[0];
            new Date() > new Date(dateObj.date) ? dateObj.datePast = true : dateObj.datePast = false;
            dateObj.items.forEach(item => {
                items.push({
                    quantity: item.count,
                    id: item.zf_id
                });
            });
            requestObj.orders.push({
                date: dateObj.date,
                items: items
            });
        });
        return requestObj;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/events.service.ts